const getBasePopupAttributes = (popupData) => {
  const requestSettings = popupData.requestSettings || {};
  return {
    type: popupData.type,
    width: requestSettings.width || popupData.width,
    height: requestSettings.height || popupData.height,
    position: { x: `${popupData.x}px`, y: `${popupData.y}px` },
    'page-idx': popupData.pageIdx,
    'z-index': popupData.zIndex,
    isGlobal: popupData.isGlobal || false,
  };
};

const getESignPopupAttributes = popupData => (popupData.eSignSettings ? {
  eSignSettings: popupData.eSignSettings,
} : {});

export const getTextPopupAttributes = popupData => ({
  value: popupData.text,
  'font-size': popupData.fontSize,
  'font-type': popupData.fontFamily,
  'font-weight': popupData.bold ? 'bold' : '',
  'font-color': popupData.color,
  'font-style': popupData.italic ? 'italic' : '',
  backgroundColor: popupData.backgroundColor || '',
});

export const getSignerPopupAttributes = popupData => (
  popupData.address ? {
    signer: popupData.address,
  } : {}
);

const getImagePopupAttributes = popupData => ({
  'img-src': popupData.imageUrl,
  'img-idx': popupData.imgIdx,
});

const getDocumentContent = (state) => {
  const content = {
    'page-zoom-level': 100,
    'user-data': [],
    'share-data': {},
    'form-id': window.FORM_ID,
    builderVersion: 2.0,
    'editor-mode': window.Editor.mode,
  };

  const popups = state.popupHandler.popups;

  const popupIds = Object.keys(popups).filter(id =>
    popups[id].type !== 'request-signature',
  );

  const requestSignaturePopupIds = Object.keys(popups).filter(id =>
    popups[id].type === 'request-signature',
  );

  popupIds.forEach((popupID) => {
    let data = {};
    const popupData = popups[popupID];
    switch (popupData.type) {
      case 'text':
        data = {
          ...getBasePopupAttributes(popupData),
          ...getESignPopupAttributes(popupData),
          ...getTextPopupAttributes(popupData),
        };
        break;
      case 'redact':
      case 'logo':
      case 'highlighter':
      case 'eraser':
        data = {
          ...getBasePopupAttributes(popupData),
          ...getImagePopupAttributes(popupData),
        };
        break;
      case 'image':
        data = {
          ...getBasePopupAttributes(popupData),
          ...getESignPopupAttributes(popupData),
          ...getImagePopupAttributes(popupData),
          'img-type': popupData.imgType,
        };
        break;
      case 'checkbox':
        data = {
          ...getBasePopupAttributes(popupData),
          checked: popupData.checked,
        };
        break;
      default:
        break;
    }

    content['user-data'].push(data);
  });

  requestSignaturePopupIds.forEach((popupID) => {
    let data = {};
    const popupData = popups[popupID];
    switch (popupData.requestType) {
      case 'date':
        data = {
          ...getBasePopupAttributes(popupData),
          ...getTextPopupAttributes(popupData.contentSettings),
          ...getSignerPopupAttributes(popupData.requestSettings),
        };
        data.type = 'text';
        data['request-type'] = popupData.requestType;
        break;
      case 'text':
        data = {
          ...getBasePopupAttributes(popupData),
          ...getTextPopupAttributes(popupData.contentSettings),
          ...getSignerPopupAttributes(popupData.requestSettings),
        };
        data.type = 'text';
        data['request-type'] = popupData.requestType;
        break;
      case 'sign':
        data = {
          ...getBasePopupAttributes(popupData),
          ...getImagePopupAttributes(popupData.contentSettings),
          ...getSignerPopupAttributes(popupData.requestSettings),
          'img-type': popupData.contentSettings.imgType,
          type: 'image',
          request: true,
        };
        break;
      default:
        break;
    }

    content['user-data'].push(data);
  });

  content['share-data'] = {
    'email-address': window.Share.emailAddress || '',
    message: window.Share.message || '',
    senderMode: window.Share.senderMode || 'sender-never',
  };

  return content;
};

export default getDocumentContent;



// WEBPACK FOOTER //
// ./src-react/FormSwiftAPI/Session/DocumentContent.jsx